import { Component } from 'preact'

import ContentCurationManager from './ContentCurationManager'

class HomepageContentCurationManager extends Component {
  constructor (props) {
    super()
    this.state = {
      enabled: props.enabled,
      curatedTopics: props.curatedTopics,
      contentCurationTitle: props.contentCurationTitle
    }
    this.setValue = this.setValue.bind(this)
  }

  componentDidUpdate () {
    const newData = {
      curatedTopics: this.state.curatedTopics.map(t => t.id),
      contentCurationTitle: this.state.contentCurationTitle,
      enabled: this.state.enabled
    }
    this.props.onChange(newData)
  }

  setValue (key, value) {
    this.setState({ [key]: value })
  }

  render (props, state) {
    return (
      <ContentCurationManager
        searchPlaceholder='Search for topics or enter a topic URL'
        visibilityText='Show curated content'
        onUpdate={(key, value) => this.setValue(key, value)}
        {...state}
      />
    )
  }
}

export default HomepageContentCurationManager
